import { render, staticRenderFns } from "./TripokeClick.vue?vue&type=template&id=419bf37a&scoped=true"
import script from "./TripokeClick.vue?vue&type=script&lang=js"
export * from "./TripokeClick.vue?vue&type=script&lang=js"
import style0 from "./TripokeClick.vue?vue&type=style&index=0&id=419bf37a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419bf37a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419bf37a')) {
      api.createRecord('419bf37a', component.options)
    } else {
      api.reload('419bf37a', component.options)
    }
    module.hot.accept("./TripokeClick.vue?vue&type=template&id=419bf37a&scoped=true", function () {
      api.rerender('419bf37a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/TripokeClick.vue"
export default component.exports